import { render, staticRenderFns } from "./ModalMedia.vue?vue&type=template&id=5f1272e9&scoped=true"
import script from "./ModalMedia.vue?vue&type=script&lang=js"
export * from "./ModalMedia.vue?vue&type=script&lang=js"
import style0 from "./ModalMedia.vue?vue&type=style&index=0&id=5f1272e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1272e9",
  null
  
)

export default component.exports